import React from 'react';
import HighlightHeader, { HighlightHeaderType } from 'client/components/highlightHeader';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

export type TestimonialsType = Array<{
  id: string;
  author: string;
  occupation: string;
  quote: string;
  location: string;
}>;

type Props = {
  testimonials: TestimonialsType;
  testimonialHeader: HighlightHeaderType;
};

const breakpoints = {
  290: {
    slidesPerView: 1,
    spaceBetween: 30,
  },
  400: {
    slidesPerView: 1.2,
    spaceBetween: 30,
  },
  500: {
    slidesPerView: 1.5,
    spaceBetween: 30,
  },
  600: {
    slidesPerView: 1.8,
    spaceBetween: 30,
  },
  640: {
    slidesPerView: 1.6,
    spaceBetween: 30,
  },
  760: {
    slidesPerView: 2,
    spaceBetween: 40,
  },
  910: {
    slidesPerView: 2.3,
    spaceBetween: 40,
  },
  1000: {
    slidesPerView: 2.5,
    spaceBetween: 40,
  },
  1100: {
    slidesPerView: 2.8,
    spaceBetween: 40,
  },
  1200: {
    slidesPerView: 3,
    spaceBetween: 40,
  },
};

const Testimonials = ({ testimonials, testimonialHeader }: Props) => (
  <section className="testimonials-section section-pad-bottom">
    <div className="row">
      <h2>
        <HighlightHeader {...testimonialHeader} />
      </h2>
      <Swiper
        autoplay={{
          delay: 0,
        }}
        className="testimonial-slider"
        speed={5500}
        loop
        spaceBetween={30}
        slidesPerView={1}
        breakpoints={breakpoints}
        modules={[Autoplay]}>
        {testimonials.map(item => (
          <SwiperSlide key={item.author}>
            <div className="testimonial-box">
              <div className="pad-bottom">{item.quote}</div>
              <div className="testimonial-box-footer">
                <div className="">
                  <div className="bold">- {item.author}</div>
                  <div>{item.occupation}</div>
                </div>
                <div>{item.location}</div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </section>
);

export default Testimonials;
